import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import Navbar from './_components/navbar'
import Footer from './_components/Footer'
import ScrollManager from './_components/ScrollManager'
import AboutPage from './pages/AboutPage'
import FeatureCategoryPage from './pages/FeatureCategoryPage'
import ProjectDetailPage from './pages/ProjectDetailPage'
import ContactOnboardingPage from './pages/ContactOnboardingPage'

export default function RoutingController() {
    
    return (
        <>
        <Navbar />
        <ScrollManager />
        <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/connect/onboarding" element={<ContactOnboardingPage />} />
            <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
            <Route path="/:slug" element={<FeatureCategoryPage />} />
        </Routes>
        <Footer />
        </>
    )
}
